export const parseParametersMargeBudgetData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'calculo-id': item.id,
      'calculo-empresa': item.empresaId,
      'calculo-categoria': item.categoriaCompactaDescricao,
      'calculo-realizada': item.margem3M,
      'calculo-proposta': item.margemAjustada
    })
  }

  return res
}
